import { createSlice } from "@reduxjs/toolkit";

import {
  videoCallPermissionGrant,
  videoCallPermissionRequest,
} from "./actions";

export type userWithRaisedHand = {
  user: number;
  type: string;
};

export interface VideocallState {
  error: any;
  data: userWithRaisedHand[];
  grantedTosession: userWithRaisedHand | null;
  loading: boolean;
}

const initialState: VideocallState = {
  loading: false,
  data: [],
  grantedTosession: null,
  error: false,
};

export const videocallSlice = createSlice({
  initialState,
  name: "videocall",
  reducers: {
    deleteHand: (state, action) => {
      state.data = state.data.filter(
        (item) => item.user !== action.payload.user
      );
    },
    raiseHand: (state, action) => {
      state.data = state.data.some((item) => item.user === action.payload.user)
        ? state.data.filter((item) => item.user !== action.payload.user)
        : [...state.data, action.payload];
    },
    clearData: (state) => {
      state.data = [];
    },
    permissionGranted: (state, action) => {
      state.grantedTosession = action.payload;
    },
    clearPermission: (state) => {
      state.grantedTosession = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(videoCallPermissionRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(videoCallPermissionRequest.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(videoCallPermissionRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
    });
    builder.addCase(videoCallPermissionGrant.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(videoCallPermissionGrant.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(videoCallPermissionGrant.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
    });
  },
});

// Action creators are generated for each case reducer function
// eslint-disable-next-line
export const {
  raiseHand,
  clearData,
  deleteHand,
  permissionGranted,
  clearPermission,
} = videocallSlice.actions;
export default videocallSlice.reducer;
